import { EssealDataTable } from "esseal-data-table";
import activityColumns from "./activityColumns";
import OverwatchModal from "@/components/OverwatchModal";

interface ShowActivitiesModalProps {
  handleClose: () => void;
  activities: Array<{
    title: string;
    description: string;
    color_code: string;
    [key: string]: unknown;
  }>;
}

export type ActivityRow = {
  title: string;
  description: string;
  color_code: string;
  id: number;
};

const ShowActivitiesModal: React.FC<ShowActivitiesModalProps> = ({
  handleClose,
  activities
}) => {
  const rows: ActivityRow[] = activities.map((activity, index) => ({
    id: index,
    ...activity
  }));

  return (
    <OverwatchModal
      size="sm"
      handleClose={handleClose}
      title="Template Activities"
    >
      <EssealDataTable
        rows={rows}
        columns={activityColumns}
        checkboxSelection={false}
        pagination={true}
        pageSize={25}
      />
    </OverwatchModal>
  );
};

export default ShowActivitiesModal;
